module.exports = __webpack_public_path__ + "static/react-90ed92dd1bdd5af16ce8ba677b8addde.png";